import { Component, ElementRef, ViewChild, AfterViewInit, ContentChild } from '@angular/core';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-content-scrollable',
  templateUrl: './content-scrollable.component.html',
  styleUrls: ['./content-scrollable.component.scss']
})
export class ContentScrollableComponent implements AfterViewInit {
  @ViewChild('scrollable', { read: ElementRef }) scrollable: ElementRef;
  @ContentChild('childComponent') childComponent;

  private isDown = false;
  private startX: number;
  private scrollLeft: number;

  ngAfterViewInit() {
    if (this.scrollable) {
      fromEvent(this.scrollable.nativeElement, 'mousedown').subscribe((ev) => this.mousedown(ev));
      fromEvent(this.scrollable.nativeElement, 'mouseup').subscribe(() => this.mouseup());
      fromEvent(this.scrollable.nativeElement, 'mousemove').subscribe((ev) => this.mousemove(ev));
      fromEvent(this.scrollable.nativeElement, 'touchstart').subscribe((ev) => this.mousedown(ev));
      fromEvent(this.scrollable.nativeElement, 'touchmove').subscribe((ev) => this.mousemove(ev));
    }
  }

  public mousedown(ev) {
    let pageX = ev.pageX;
    if (ev instanceof TouchEvent) {
      const changed = ev.changedTouches[0];
      pageX = changed.pageX;
    }
    this.isDown = true;
    this.scrollable.nativeElement.classList.add('active');
    this.startX = pageX - this.scrollable.nativeElement.offsetLeft;
    this.scrollLeft = this.scrollable.nativeElement.scrollLeft;
  }

  public mouseup() {
    this.isDown = false;
    this.scrollable.nativeElement.classList.remove('active');
  }

  public mousemove(ev) {
    if (!this.isDown) { return; }
    ev.preventDefault();
    let pageX = ev.pageX;
    if (ev instanceof TouchEvent) {
      const changed = ev.changedTouches[0];
      pageX = changed.pageX;
    }
    const x = pageX - this.scrollable.nativeElement.offsetLeft;
    const walk = x - this.startX;
    this.scrollable.nativeElement.scrollLeft = this.scrollLeft - walk;
  }

}
